import { render, staticRenderFns } from "./SwopVehicle.vue?vue&type=template&id=aa05637a&scoped=true"
import script from "./SwopVehicle.vue?vue&type=script&lang=js"
export * from "./SwopVehicle.vue?vue&type=script&lang=js"
import style0 from "./SwopVehicle.vue?vue&type=style&index=0&id=aa05637a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa05637a",
  null
  
)

export default component.exports